import { Col, Divider, Row, Table, Typography, Select } from "antd";
import useProcurementStore from "store/procurement_store";

import {
  getCommvaultData,
} from "apis";
import React, { useEffect, useState } from "react";
import AmortizationTable from "./AmortizationTable";
import ActionPage from "./ActionPage";
import MasterAmortizationTable from "./MasterAmortizationTable";
import MasterActionPage from "./MasterActionPage";
import { DataProvider } from './DataContext';
import { DatabaseManager } from "helpers/db";
import { Input, notification } from "antd";
import {
  ENTITY_TYPES,
  PROCUREMENT_STAGES,
  PROCUREMENT_STATUS,
  PROCUREMENT_TYPES,
} from "types";

import {
  extractEmailsFromString,
  generateDefaultProcurementName,
  get_html,
  replace_vars,
} from "helpers";
import { getUserIdentity } from "helpers/auth";
import { IsProcurementCommsComponentEnable } from "helpers/cognitogroups";

const { Text } = Typography;
const { Option } = Select;

const MasterCommVaultData = ({setIsSubmitting, site_code, Commserve}) => {
  const siteCodeObj = {
    "AMP": "Sydney,Australia",
    "BGO": "Bendigo",
    "DAC": "Menuma",
    "HZH": "Hangzhou",
    "NCN": "Ningbo",
    "SGP": "Singapore (we can plan for decomm or reuse)",
    "UPH": "Upper Hut",
    "WBC": "Beijing",
    "BCL": "Carlow",
    "BCP": "Moscow",
    "BOX": "Boxmeer (planned for 1 more device)",
    "BRI": "Brinny",
    "BTE": "Ballydine",
    "BUR": "Burgwedel",
    "CLG": "Cologne",
    "DBT": "De-Bilt",
    "FRS": "Friesohyte",
    "HAN": "Haarlem",
    "HDE": "Hoddesdon(planned for Decomm)",
    "HEI": "Heist (TSA Site till end of this year)",
    "IGV": "Igoville",
    "IRD": "Dunboyne",
    "KRE": "Krems",
    "LOK": "London",
    "MKS": "Milton keynes",
    "NLAME": "Amsterdam",
    "NLE": "Cramlington (TSA Site till end of this year)",
    "OS3": "OSS - VEERSEMEER",
    "RCF": "Mirable France (site sold)",
    "SAL": "Salamanca",
    "SDB": "Dublin",
    "SOA": "MIDRAND, SOUTH AFRICA",
    "SWB": "Schwabenheim",
    "USH": "Unterschleissheim",
    "VN2": "Vienna",
    "WAG": "Schachen, CH (Werthenstein)",
    "BMB": "Boston",
    "BMG": "MonteCarlos",
    "CTC": "Charlotte",
    "DVP": "Cherokke",
    "EKV": "Elkton",
    "ELK": "Elkhorn",
    "KTC": "Kenilworth",
    "LPD": "Las Piedras",
    "ML2": "Millsboro",
    "PLT": "Lower Gwynedd",
    "POD1": "Wilson",
    "SAF": "San Fransisco",
    "SRS": "Durham",
    "UGP": "Upper Gwynedd",
    "WIN": "Wilson",
    "WPP": "West Point",
    "RYN": "Rahway"
  }
  
  const siteCodeMap = new Map(Object.entries(siteCodeObj));
  const res = site_code;
  const [siteCode, setSiteCode] = useState(res);
  const [shouldCallAPI, setShouldCallAPI] = useState(siteCodeMap.has(res));

  console.log("mounting CommVault")
 
  const [items, setItems] = useState([]);
  const [isUserAllowed,setIsUserAllowed] = useState(false);

  useEffect( () => {
     getCommvaultDataFunc("demo", siteCode)
  },[shouldCallAPI,siteCode])

  useEffect(() => {
    fetchUserIdentity()
  }, []);

  const fetchUserIdentity = async () => {
    const userIdentity = await getUserIdentity();
    setIsUserAllowed(IsProcurementCommsComponentEnable("MasterCommVault", userIdentity?.cognito_groups));
  };

  const getCommvaultDataFunc = async (r,sc) => {
    setIsSubmitting(true)
    try {
      let cdResponse = await getCommvaultData(r, sc);
      console.log(cdResponse)

      if (cdResponse.success) {
        setItems(cdResponse?.data?.body?.data);
      }  
    }
    catch (error) {
      console.error('API Error:', error);
    } 
    finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  console.log(items,"items")
  const uniquePoolNames = [...new Set(items.filter(item => item?.Generation?.length > 0 && Number(item?.Generation[0]) == 11).map(item => item.StoragePoolName))];
  console.log(uniquePoolNames)

  // Helper function to extract t-shirt size and generation from model name
  const extractTshirtSizeAndGen = (modelName) => {
    if (!modelName) return { tshirtSize: null, generation: null };
    
    const parts = modelName.split(' ');
    if (parts.length < 3) return { tshirtSize: null, generation: null };
    
    // Skip first word, second word is t-shirt size, after that is generation
    const tshirtSize = parts[1]; // e.g., "DL380", "DL360", "DL320", "XL420", "RX250"
    const generation = parts.slice(2).join(' '); // e.g., "Gen10", "Gen10 Plus", "Gen11", "M4"
    
    return { tshirtSize, generation };
  };

  // Generate gen11storagepools with storage pool, t-shirt size, and generation info
  const gen11storagepools = items
    .filter((item) => item?.Generation?.length > 0 && Number(item?.Generation[0]) === 11)
    .map((item) => {
      const models = item?.nodesInfo?.map(node => node?.model || '') || [];
      const modelInfo = models.map(model => extractTshirtSizeAndGen(model));
      
      // Get the first valid t-shirt size and generation (since there will be only one per storage pool)
      const tshirtSize = modelInfo.find(info => info.tshirtSize)?.tshirtSize || null;
      const generation = modelInfo.find(info => info.generation)?.generation || null;
      
      return {
        storagePoolName: item.StoragePoolName,
        tshirtSize: tshirtSize,
        generation: generation,
        // models: models.filter(Boolean)
      };
    });


  // Calculate aggregated values for master components
  const totalUsedSpace = items.reduce((sum, item) => sum + (item.TotalUsedSpace || 0), 0).toFixed(2);
  const totalCapacity = items.reduce((sum, item) => sum + (item.Capacity || 0), 0).toFixed(2);

  // Extract t-shirt sizes and generations from model data
  const extractModelInfo = () => {
    const tshirtSizes = new Set();
    const generations = new Set();
    const brandNames = new Set();

    items.forEach(item => {
      item?.nodesInfo?.forEach(node => {
        const model = node?.model || '';
        
        if (model.trim()) {
          const parts = model.trim().split(/\s+/);
          
          if (parts.length >= 2) {
            // Extract brand name (first word)
            const brandName = parts[0];
            brandNames.add(brandName);
            
            // Extract t-shirt size (second word)
            const tshirtSize = parts[1];
            tshirtSizes.add(tshirtSize);
            
            // Extract generation (everything after t-shirt size)
            if (parts.length > 2) {
              const generation = parts.slice(2).join(' ');
              if (generation) {
                generations.add(generation);
              }
            }
          }
        }
      });
    });

    return {
      tshirtSizes: Array.from(tshirtSizes),
      generations: Array.from(generations),
      brandNames: Array.from(brandNames)
    };
  };

  const modelInfo = extractModelInfo();

  const resourcesColumns = [
    {
      title: "Commserve",
      dataIndex: "Commserve",
      key: "Commserve",
    },
    {
      title: "Storage Pool Name",
      dataIndex: "StoragePoolName",
      key: "StoragePoolName",
    },
    {
      title: "Library Name",
      dataIndex: "LibraryName",
      key: "LibraryName",
    },
    {
      title: "Free Space (TB)",
      dataIndex: "FreeSpace",
      key: "FreeSpace",
    },
    {
        title: "Capacity (TB)",
        dataIndex: "Capacity",
        key: "Capacity",
      },
      {
        title: "Percent Free",
        dataIndex: "PercentFree",
        key: "PercentFree",
      },
      {
        title: "Total Used Space (TB)",
        dataIndex: "TotalUsedSpace",
        key: "TotalUsedSpace",
      },
      {
        title: "Library Type",
        dataIndex: "LibraryType",
        key: "LibraryType",
      },
      {
        title: "Number Of Nodes",
        dataIndex: "NumberOfNodes",
        key: "NumberOfNodes",
      },
      {
        title: "Model",
        dataIndex: "Models",
        key: "Models",
      },
      {
        title: "Node Names",
        dataIndex: "MediaAgentNames",
        key: "MediaAgentNames",
      },
      {
        title: "Generation",
        dataIndex: "Generation",
        key: "Generation",
      },
  ];

  const resourcesData = items.map((item, index) => ({
    key: index,
    Commserve: <Text>{item?.Commserve}</Text>,
    StoragePoolName: <Text>{item?.StoragePoolName}</Text>,
    LibraryName: <Text>{item?.LibraryName}</Text>,
    FreeSpace: <Text>{item?.FreeSpace} TB</Text>,
    Capacity: <Text>{item?.Capacity} TB</Text>,
    PercentFree: <Text>{item?.PercentFree} %</Text>,
    TotalUsedSpace: <Text>{item?.TotalUsedSpace} TB</Text>,
    LibraryType: <Text>{item?.LibraryType}</Text>,
    NumberOfNodes: <Text>{item?.NumberOfNodes}</Text>,
    Models: item?.nodesInfo.map((it, index) => (
      <span key={index} style={{
              height: '50px',
              borderBottom: index < item.nodesInfo.length - 1 ? '1px solid #ccc' : 'none',
              display: 'flex',
              alignItems: 'center',
            }}>
        <Text key={index} style={{ display: 'block' }}>
          {it?.model}
        </Text>
      </span>
    )),
    Generation: item?.nodesInfo.map((it, index) => (
      <span key={index} style={{
              height: '50px',
              borderBottom: index < item.nodesInfo.length - 1 ? '1px solid #ccc' : 'none',
              display: 'flex',
              alignItems: 'center',
            }}>
        <Text key={index} style={{ display: 'block' }}>
          {it?.generation}
        </Text>
      </span>
    )),
    MediaAgentNames: item?.nodesInfo.map((it, index) => (
      <span key={index} style={{
              height: '50px',
              borderBottom: index < item.nodesInfo.length - 1 ? '1px solid #ccc' : 'none',
              display: 'flex',
              alignItems: 'center',
            }}>
        <Text key={index} style={{ display: 'block' }}>
          {it?.mediaAgentName}
        </Text>
      </span>
    ))
  }));

  return (
    <div>
      <Text strong> Commvault Details :</Text>
       {!siteCodeMap.has(res) && (
        <div style={{ marginBottom: '16px' }}>
          <p>Please select a valid site code:</p>
          <Select
            style={{ width: 400 }}
            placeholder="Select site"
            value={siteCode}
            onChange={(value) => {
              setSiteCode(value);
              setShouldCallAPI(true);
            }}
          >
            {[...siteCodeMap.entries()].map(([code, site]) => (
              <Option key={code} value={code}>{code} - {site}</Option>
            ))}
          </Select>
        </div>
      )}
      <Row style={{ marginBottom: "30px", marginTop: "10px" }}>
        <Col span={24}>
          <Table
            dataSource={resourcesData}
            columns={resourcesColumns}
            pagination={false}
            bordered
            size="small"
            style={{ marginBottom: "20px" }}
            scroll={{ x: 1200 }}
          />
        </Col>
      </Row>
      <Divider />
      <DataProvider>
        <MasterAmortizationTable 
          usedSpace={totalUsedSpace} 
          totalSpace={totalCapacity} 
          isUserAllowed={isUserAllowed} 
        />
        <MasterActionPage  
          Commserve={Commserve} 
          siteCode={siteCode} 
          siteName={siteCodeMap.get(siteCode)} 
          setSiteCode={setSiteCode} 
          setShouldCallAPI={setShouldCallAPI} 
          uniquePoolNames={uniquePoolNames} 
          setIsSubmitting={setIsSubmitting} 
          isUserAllowed={isUserAllowed}
          usedSpace={totalUsedSpace}
          totalSpace={totalCapacity}
          modelInfo={modelInfo}
          gen11storagepools={gen11storagepools}
        />
      </DataProvider>
    </div>
  );
};

export default MasterCommVaultData;